import React from 'react'

const borderWith = 120;
const paddingBorder = 10;
const borderColor = "#B71F3E";
const verticalGap = 121;
const horizontalGap = 121;
const borderLineWidth = 1;
const gapPaddingLineAndCorner = 5;

function Border() {
    return <div style={{
        position: "absolute",
        width: "100%",
        height: '100%',
        top: 0,
        left: 0,
        pointerEvents: "none",
    }}>
        <div className="border-line" style={{
            borderLeft: `${borderLineWidth}px solid ${borderColor}`,
            borderRight: `${borderLineWidth}px solid ${borderColor}`,
            top: verticalGap,
            left: paddingBorder + gapPaddingLineAndCorner,
            height: `calc(100% - ${verticalGap*2}px)`,
            clipPath: `polygon(
                0 3px,
                100% 0,
                100% 100%,
                0% calc(100% - 3px) 
            )`,
        }}/>
        <div className="border-line" style={{
            borderTop: `1px solid ${borderColor}`,
            borderBottom: `1px solid ${borderColor}`,
            top: paddingBorder + gapPaddingLineAndCorner,
            left: horizontalGap,
            width: `calc(100% - ${horizontalGap*2}px)`,
            clipPath: `polygon(
                3px 0,
                calc(100% - 3px) 0,
                100% 100%,
                0 100%
            )`,
        }}/>
        <div className="border-line" style={{
            borderLeft: `${borderLineWidth}px solid ${borderColor}`,
            borderRight: `${borderLineWidth}px solid ${borderColor}`,
            top: verticalGap,
            right: paddingBorder + gapPaddingLineAndCorner,
            height: `calc(100% - ${verticalGap*2}px)`,
            clipPath: `polygon(
                0 0,
                100% 3px,
                100% calc(100% - 3px),
                0% 100% 
            )`,
        }}/>
        <div className="border-line" style={{
            borderTop: `1px solid ${borderColor}`,
            borderBottom: `1px solid ${borderColor}`,
            bottom: paddingBorder + gapPaddingLineAndCorner,
            left: horizontalGap,
            width: `calc(100% - ${horizontalGap*2}px)`,
            clipPath: `polygon(
                0 0,
                100% 0,
                calc(100% - 3px) 100%,
                3px 100%
            )`,
        }}/>
        <img alt="border" src='/img/border-cover.png' className='border-img' style={{ top: paddingBorder, left: paddingBorder, transform: "scaleY(-1)" }} width={borderWith} />
        <img alt="border" src='/img/border-cover.png' className='border-img' style={{ top: paddingBorder, right: paddingBorder, transform: "scale(-1)" }} width={borderWith} />
        <img alt="border" src='/img/border-cover.png' className='border-img' style={{ bottom: paddingBorder, right: paddingBorder, transform: "scaleX(-1)" }} width={borderWith} />
        <img alt="border" src='/img/border-cover.png' className='border-img' style={{ bottom: paddingBorder, left: paddingBorder }} width={borderWith} />
    </div>
}

export default function WeddingSection({ children, border = false }) {
    return <div className='wedding-section'>
        {border && <Border />}
        {children}
    </div>
}
